<template>
  <transition name="toast">
    <div v-if="visible" class="toast-message" :class="type">
      <i :class="icon" aria-hidden="true" />
      {{ message }}
    </div>
  </transition>
</template>

<script>
export default {
  name: 'ToastMessage',
  props: {
    visible: { type: Boolean, default: false },
    message: { type: String, default: '' },
    type: { type: String, default: 'info' }
  },
  computed: {
    icon() {
      if (this.type === 'success') return 'el-icon-circle-check'
      if (this.type === 'error') return 'el-icon-circle-close'
      return 'el-icon-info'
    }
  }
}
</script>

<style scoped>
.toast-message {
  position: fixed;
  top: 80px;
  left: 50%;
  z-index: 10000;
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 11px 20px;
  transform: translateX(-50%);
  color: #fff;
  border-radius: 10px;
  background: var(--up-blue);
  box-shadow: 0 10px 28px rgba(20, 16, 45, 0.22);
  font-size: 13.5px;
  font-weight: 600;
  white-space: nowrap;
}

.toast-message.success {
  background: #0e9f5c;
}

.toast-message.error {
  background: #d92d20;
}

.toast-enter-active,
.toast-leave-active {
  transition: 0.2s ease;
}

.toast-enter,
.toast-leave-to {
  opacity: 0;
  transform: translate(-50%, -10px);
}
</style>
